import { render, staticRenderFns } from "./DynamicLoggerList.vue?vue&type=template&id=1577375c&scoped=true"
import script from "./DynamicLoggerList.vue?vue&type=script&lang=js"
export * from "./DynamicLoggerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1577375c",
  null
  
)

export default component.exports